module.exports = __webpack_public_path__ + "img/nolan-registration.b554db50.svg";